export const WALLET_REFRESH_EVENT = "dreamsport:wallet-refresh";

/** Notify header and other listeners to reload wallet balance. */
export function requestWalletRefresh() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(WALLET_REFRESH_EVENT));
  }
}

/** True when an API action response indicates the wallet balance may have changed. */
export function shouldRefreshWalletAfterMutation(response) {
  return response?.status === true;
}

/**
 * After a successful order / fill-open / cash-out mutation, tell all wallet
 * listeners (header, straight-bet page, etc.) to refetch balance.
 */
export function refreshWalletAfterMutation(response) {
  if (shouldRefreshWalletAfterMutation(response)) {
    requestWalletRefresh();
  }
  return response;
}
